<template>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <md-card class="md-card-product md-card-website">
            <md-card-header 
                            class="md-card-header-image">
                <img class="img" :src="website.imgUrl" />
            </md-card-header>

            <md-card-content>
                <h4 class="title">
                    {{website.name}}
                </h4>
                <div class="card-description">
                    {{website.description}}
                </div>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
                <div class="stats">
                    <md-button class="md-primary" :href="website.previewUrl" target="_blank">
                        Preview
                        <md-tooltip md-direction="bottom">Preview Website</md-tooltip>
                    </md-button>
                </div>
                <div class="price">
                       <md-button class="md-primary" @click="approveWebsite(website)">
                        Approve
                        <md-tooltip md-direction="bottom">Approve Website for publication to Tenants</md-tooltip>
                    </md-button>
                </div>
            </md-card-actions>
        </md-card>
   </div>
</template>
<script>
    export default {
        //name: "WebsiteCard",
        props: {
            website: {}
        },
        data() {
            return {
            };
        },
        computed: {
           
        },
        methods: {
            approveWebsite(website) {
                this.$emit('approveWebsite', website)
            }
        }
    };
</script>
